import { QueryState } from 'app/lib/constants';
import { fqnEquals, toStringFqn } from 'app/lib/utils';
import { doDeleteFQNQuery, doLookupAndCancelQuery } from 'app/store/snowflakeQueries/actions.js';
import { selectQueryMetadataForPropFQN } from 'app/store/snowflakeQueries/selectors.js';
import { selectCurrentFqn } from './selectors.js';
import {
    GET_COLUMN_METADATA,
    GET_SNOWFLAKE_TABLE_COLUMNS,
    SELECT_TAB,
    SELECT_TABLE
} from './types.js';

export const doSelectTable = (fqn) => ({
    type: SELECT_TABLE,
    payload: { fqn },
    immediateEffect: ({ store }) => {
        const state = store.getState();
        const selectedFqn = selectCurrentFqn(state);

        if (selectedFqn && !fqnEquals(selectedFqn, fqn)) {
            const metadata = selectQueryMetadataForPropFQN(state, { fqn: selectedFqn });

            if (metadata.state === QueryState.RUNNING) {
                store.dispatch(doLookupAndCancelQuery(['byFQN', toStringFqn(selectedFqn)]));
                store.dispatch(doDeleteFQNQuery({ fqn: selectedFqn }));
            }
        }
    }
});

export const doSelectTab = (id) => ({
    type: SELECT_TAB,
    payload: { id }
});

export const doGetColumnMetadata = (fqn, columnNames) => ({
    type: GET_COLUMN_METADATA,
    api: { version: 2, name: 'GetColumnMetadata' },
    params: {
        viewUuid: fqn,
        columnNames
    },
    meta: {
        fqn
    }
});

export const doGetSnowflakeTableColumns = (fqn) => ({
    type: GET_SNOWFLAKE_TABLE_COLUMNS,
    api: { version: 2, name: 'FetchSnowflakeTableColumns' },
    params: {
        database: fqn.database,
        schema: fqn.schema,
        table: fqn.table
    },
    meta: {
        fqn
    }
});
